import { useEnv } from "@RHCommerceDev/hooks/useEnv";

const env = useEnv();

const HEADER_HEIGHTS = {
  xs: {
    cartPage: 82,
    regularPage: 106
  },
  default: {
    cartPage: 132,
    regularPage: {
      nav: 136,
      newNav: 195
    }
  }
} as const;

export const getRhrHeaderHeight = (
  isCartPage: boolean,
  size: "default" | "xs"
): number => {
  if (size === "xs") {
    return isCartPage
      ? HEADER_HEIGHTS.xs.cartPage
      : HEADER_HEIGHTS.xs.regularPage;
  }

  if (isCartPage) {
    return HEADER_HEIGHTS.default.cartPage;
  }

  return HEADER_HEIGHTS.default.regularPage.nav;
};
